import type { App, Component } from 'vue';
import consola from 'consola';
import AxCard from './AxCard.vue';
import AxMultiSelectUsers from './AxMultiSelectUsers.vue';
import AxSelectUsers from './AxSelectUsers.vue';
import AxModalLoading from './AxModalLoading.vue';
import AxMenuButton from './AxMenuButton.vue';
import type { Plugin } from 'vue';
import AxFileIcon from './AxFileIcon.vue';
import AxFolderButton from './AxFolderButton.vue';
import AxWorkflowDot from './AxWorkflowDot.vue';
import AxFormCnCompletion from './AxFormCnCompletion.vue';

export const uiBlocksPlugin: Plugin = {
    install: async (app: App) => {
        try {
            Object.entries(uiBlocks).forEach(([name, component]) => {
                app.component(name, component);
            });

            if (import.meta.env.MODE === 'development') {
                consola.success('Blocks UI registered');
            }
        } catch (error) {
            consola.error('Error registering blocks UI:', error);
        }
    },
};

const uiBlocks: Record<string, Component> = {
    AxCard,
    AxMultiSelectUsers,
    AxSelectUsers,
    AxModalLoading,
    AxFileIcon,
    AxMenuButton,
    AxFolderButton,
    AxWorkflowDot,
    AxFormCnCompletion,
};

export { uiBlocks };
